import { style } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { IListByFilterQuestionarios, IQuestionarios } from './models/questionarios';
import { QuestionariosService } from './services/questionarios.service';

@Component({
  selector: 'app-questionarios',
  templateUrl: './questionarios.component.html',
  styleUrls: ['./questionarios.component.scss']
})
export class QuestionariosComponent {
  ERoleAdminString = ERoleAdminString;
  formAberto = false;
  acaoInput = new UntypedFormControl();
  ordenarControl = new UntypedFormControl(1);
  questionarios: IQuestionarios[] = [];
  opcoesOrdenacao = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];

  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };


  constructor(
    readonly sessionService: SessionService,
    readonly questionariosService: QuestionariosService

  ) { }

  ngOnInit(): void {
    this.carregarQuestionarios();

    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarQuestionarios();
    });

  }


  filtrarFilial(): void {
    this.carregarQuestionarios();
  }

  limparFiltros(): void {
    this.acaoInput.reset();
    this.carregarQuestionarios();
  }

  carregarQuestionarios(): void {
    const filtros: IListByFilterQuestionarios = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }
    const companyId = this.sessionService.getSession().companyId;

    if (companyId) {
      filtros.companyId = companyId;
    }

    this.questionariosService.listarTodasQuestionarios(filtros).subscribe((res) => {
      this.questionarios = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarQuestionarios();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;

    this.carregarQuestionarios();
  }

  //public downloadExcel(): void {
  //this.filiaisservice.exportarExcel();
  // }

}
